export enum SpamScenarioId {
    BlockedSendersAndDomains = 1, // Option scenario for blocked senders and domains spam setting
    SafeSendersAndDomains = 2, // Option scenario for safe senders or domains spam setting
    SafeMailingLists = 3, // Option scenario for safe mailing lists spam setting
    AllowedDynamicEmailSenders = 4, // Option scenario for allowed dynamic email senders settings
}

export default SpamScenarioId;
